<template>
	<div class="custom-input" :class="{required: data.required}">
        <!-- <label>{{ data.label }}</label> -->
		<nut-textinput
			:has-border="false"
			:placeholder="data.placeholder"
		></nut-textinput>
	</div>
</template>

<script>
export default {
	name: 'custom-input',
	props: ['data'],
	mounted() {

	},
}
</script>

<style lang="less" scoped>
/deep/ .nut-textinput input {
    padding-left: 0;
}
</style>
